export const reportTemplatesApi = (client) => ({
    list: () => client.get('/api/v1/report-templates').then((r) => r.data),
    /** id/name/is_default only, no html_content — for pickers (create/
     *  edit work order or task form, workflow step config). */
    listSummaries: () => client.get('/api/v1/report-templates/summary').then((r) => r.data),
    get: (id) => client.get(`/api/v1/report-templates/${id}`).then((r) => r.data),
    create: (body) => client.post('/api/v1/report-templates', body).then((r) => r.data),
    update: (id, body) => client.patch(`/api/v1/report-templates/${id}`, body).then((r) => r.data),
    remove: (id) => client.delete(`/api/v1/report-templates/${id}`).then(() => undefined),
    /** Makes this the sole default for its resource_type — the backend
     *  unsets whatever else was default in the same transaction. */
    setDefault: (id) => client.post(`/api/v1/report-templates/${id}/set-default`).then((r) => r.data),
});
//# sourceMappingURL=report-templates.js.map